export default {
  root: {
    padding: 24,
    "&:last-child": {
      paddingBottom: 'none'
    }
  },
};
